































































import MSelect from "@/components/utility/mmmint/MSelect.vue";
import MTextField from "@/components/utility/mmmint/MTextField.vue";
import { RepairStatusEnum } from "@/lib/enum/repair.enum";
import { IReport } from "@/models/report.entity";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {
    MTextField,
    MSelect
  }
})
export default class PartnerReportRepairInfo extends Vue {
  @Prop({ required: true }) readonly report!: IReport;

  get repair() {
    return this.report.repair;
  }

  get statusItems() {
    return Object.values(RepairStatusEnum).map(value => ({
      value,
      text: this.$t(`enums.RepairStatusEnum.${value}`)
    }));
  }

  get rentalProvidedItems() {
    return [true, false].map(value => ({
      value,
      text: value ? this.$t("yes").toString() : this.$t("no").toString()
    }));
  }
}
